export function formatCubicMeters(value: number, locale = 'en-CH') {
  return Math.round(value)
    .toLocaleString(locale)
    .replace(/\u2019/g, "'");
}
